import React,{useEffect, useState, useRef} from 'react'
import './App.css';
import { BrowserRouter,Routes,Route } from "react-router-dom";
import Login from './components/login/LoginComponent';
import Index from './components/index/IndexComponent';
import Activate from './components/activate/ActivateComponent';
import Forgot from './components/forgot/ForgotComponent';
import UserComponent from './components/user/UserComponent';
import LanguageComponent from './components/language/LanguageComponent';
import Sign from './components/sign/SignComponent';
import {Grid  } from '@mui/material';
import {apiLogin} from './services/api/accounts/Login';
import { useTranslation } from "react-i18next";

const isAuthenticated = localStorage.getItem('token') != null && localStorage.getItem('token') != '';
const role = localStorage.getItem('role');
const email = localStorage.getItem('email');
const fullName = localStorage.getItem('fullName');
const initial = localStorage.getItem('firstName')!==null ? (localStorage.getItem('firstName').substring(0,1)+''+localStorage.getItem('lastName').substring(0,1)):'';
const avatar = localStorage.getItem('avatar') != null ? localStorage.getItem('avatar') : null;

const App = (props, match) => {
    const [items, setItems] = useState([]);
    const [isMenu, setIsMenu] = useState(false);
    const [isBlur, setIsBlur] = useState(false);
    const [isNotification, setIsNotification] = useState(false);
    const [isOpenUser, setIsOpenUser] = useState(false);
    const [isOpenTemplates, setIsOpenTemplates] = useState(false);
    const [isOpenLanguage, setIsOpenLanguage] = useState(false);
    const [activeView, setActiveView] = useState('documents');
    const [isOpenPayLoad, setIsOpenPayLoad] = useState(false);
    const [isOpenPay, setIsOpenPay] = useState(false);
    const [currentUser, setCurrentUser] = useState(false);
    const [language, setLanguage] = useState('PL');
    const [languageText, setLanguageText] = useState('Polski');
    const { t, i18n, ready } = useTranslation();
    const anchorRef = useRef(null);

    useEffect(() => {
      async function fetchData() {
          await refreshItems();
          //window["loadWindow"]();

          if(localStorage.getItem('Language')==='PL')
          {
              setLanguage('PL');
              setLanguageText('Polski');
          }
          else if(localStorage.getItem('Language')==='EN')
          {
              setLanguage('EN');
              setLanguageText('English');
          }
          else if(localStorage.getItem('Language')==='FR')
          {
              setLanguage('FR');
              setLanguageText('Français');
          }

          let user = await apiLogin.getCurrentUser();
          if(user!==null)
          {
              setCurrentUser(user);
          }
      }
      fetchData();

    }, []);

    const refreshItems = async ()=>{
      let data = await apiLogin.getNotificationUser();
      if (data && data.items) {
        setItems(data.items);
      }
    }

    const logOff = () =>{
      localStorage.setItem('token', '');
      localStorage.setItem('fullName', '');
      localStorage.setItem('role', '');
      localStorage.setItem('email', '');
      localStorage.setItem('avatar', '');
      window.location.href = "/";
    }

    const closeAll = () => {
      setIsMenu(false);
      setIsOpenLanguage(false);
      setIsOpenUser(false);
    }

    const showUser = () =>{
      setIsOpenUser(true);
      closeAll();
      setIsOpenUser(true);
    }

    const readNotification = async (id, documentId) =>{
      let data = await apiLogin.readNotifcation(id);
      window.location.href = "/sign?id="+documentId;
    }

    const showLanguage = () =>{
      setIsMenu(false);
      closeAll();
      setIsOpenLanguage(true);
    }

    const showDocuments = () =>{
      setIsMenu(false);
      closeAll();
      setActiveView('documents');
    }

    const showUsers = () =>{
      setIsMenu(false);
      closeAll();
      setActiveView('users');
    }

    return (
      <div>
        <div className={(email===null || email==='') ? 'top-2':'top'}>
            {(email===null || email==='') &&
              <div className={`main-wrapper`}>
                <Grid container>
                    <Grid item style={{maxWidth: "130px"}}>
                      <a href="/login" className='logo'></a>
                    </Grid>
                    <Grid item xs>
                    </Grid>
                    <Grid item style={{maxWidth: "100px"}}>
                        <a className="language not-mobile" onClick={()=>showLanguage()}><i className='language-svg not-mobile'></i>&nbsp;&nbsp;{language}</a>
                    </Grid>
                </Grid>
              </div>
            }
            {email!==null && email!=='' &&
              <Grid container alignItems="center">
                  <Grid item style={{maxWidth: "130px"}}>
                    <a href="/login" className='logo'></a>
                  </Grid>
                  <Grid item xs>
                  </Grid>
                  <Grid item>
                    <a className={`menu-item header-nav${activeView === 'documents' ? ' menu-item-active' : ''}`} onClick={()=>showDocuments()}><i className="template-icon"></i>&nbsp;{t("index_text2")}</a>
                  </Grid>
                  {localStorage.getItem('role')==='1' &&
                    <Grid item style={{marginLeft: '24px'}}>
                      <a className={`menu-item header-nav${activeView === 'users' ? ' menu-item-active' : ''}`} onClick={()=>showUsers()}><i className="company-icon"></i>&nbsp;{t("app_text3")}</a>
                    </Grid>
                  }
                  <Grid item>
                    <a className="language" onClick={()=>showLanguage()}><i className='language-svg'></i>&nbsp;&nbsp;{language}</a>
                  </Grid>
                  <Grid item style={{marginTop: "5px"}} className="right-element">
                    <a className='full-name'><i className='notification-icon' onClick={()=>{setIsNotification(!isNotification);setIsMenu(false);}} onMouseEnter={()=>{setIsNotification(true);setIsMenu(false);}}></i>
                    <span onClick={()=>setIsMenu(!isMenu)} className='initial2'>{initial}</span>
                    </a>
                    {isNotification && <ul className='menu' onMouseLeave={()=>setIsNotification(false)}>
                      {items.map((row, index) => {
                        return(<li key={index} className='notification'>
                            <Grid container>
                              <Grid item xs={12}>
                                <b>{row.createdDateName}</b>
                              </Grid>
                              <Grid item xs={12}>
                                {row.description.indexOf('został podpisany')>0 &&
                                  <h5>Nowy podpis</h5>
                                }
                                {row.description.indexOf('został podpisany')<=0 &&
                                  <h5>Podpisz dokument</h5>
                                }
                              </Grid>
                              <Grid item xs={12}>
                                <p onClick={()=>readNotification(row.id,row.documentId)}>{row.description}</p>
                              </Grid>
                            </Grid>
                          </li>)
                      })}
                    </ul>
                    }
                    {isMenu && <ul className='menu' onMouseLeave={()=>setIsMenu(false)}>
                      <li onClick={()=>showUser()}>{t("app_text1")}</li>
                      <li><a onClick={()=>{logOff()}}>{t("app_text6")}</a></li>
                    </ul>
                    }
                  </Grid>
              </Grid>
            }
            {email!==null && email!=='' &&
              <div className={`main-wrapper`}>
                <Grid container>
                    <UserComponent isOpenUser={isOpenUser} setIsOpenUser={setIsOpenUser} setIsOpenPayLoad={setIsOpenPayLoad} setIsBlur={setIsBlur}></UserComponent>
                </Grid>
              </div>
            }
        </div>
        {email!==null && email!=='' &&
          <Grid container style={{display: 'none'}}>
            <Grid item className='left-menu'>
                <Grid container className='mt-10 ml-10'>
                    <Grid item xs={2}>
                      <span className='initial'>{initial}</span>
                    </Grid>
                    <Grid item xs>
                        <Grid container>
                             <Grid item>
                                <p className='fullName'>{fullName}</p>
                             </Grid>
                        </Grid>
                        <Grid container>
                             <Grid item>
                                {currentUser.deadline &&
                                  <a className='account-type'><i className='account-icon'></i>&nbsp;{t("app_text20")}</a>
                                }
                                {!currentUser.deadline &&
                                  <a className='account-type'><i className='account-icon'></i>&nbsp;{t("app_text21")}</a>
                                }
                             </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br/>
                <Grid container>
                  <Grid item xs={12}>
                    <p className="menu-info">{t("app_text21b")}</p>
                  </Grid>
                  <Grid item xs={12} className='mt-6'>
                    <a className={`menu-item${activeView === 'documents' ? ' menu-item-active' : ''}`} onClick={()=>showDocuments()}><i class="template-icon"></i>&nbsp;{t("index_text2")}</a>
                  </Grid>
                    <Grid item xs={12} className='mt-6'>
                        <a className={`menu-item${activeView === 'users' ? ' menu-item-active' : ''}`} onClick={()=>showUsers()}><i class="company-icon"></i>&nbsp;{t("app_text3")}</a>
                    </Grid>
                </Grid>
                <br/>
                <Grid container>

                </Grid>
                <Grid container className='bottom-options'>
                  <Grid item xs={12}>
                    <a className="menu-item logout-button" onClick={()=>logOff()}><a className='logout-sub'><i class="logout-icon"></i>&nbsp;{t("app_text31")}</a></a>
                  </Grid>
                  <Grid item xs={12}>
                    <a className='bottom-href' href="https://signsafe.app/regulamin-serwisu-internetowego/">{t("app_text32")}</a>
                    <a className='bottom-href text-right' href="https://signsafe.app/polityka-prywatnosci/">{t("app_text33")}</a>
                  </Grid>
                  <Grid item xs={12}>
                    <a className='bottom-href text-right' onClick={()=>{setIsOpenLanguage(true)}}>{t("app_text35")}: {languageText}</a>
                  </Grid>
                </Grid>
            </Grid>
          </Grid>
        }
        <div id="all" className={`
            ${email ? 'all' : ''}
          `.trim()} >
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />}></Route>
              <Route path="sign" element={<Sign />} />
              <Route path="login" element={<Login />} />
              <Route path="index" element={<Index setIsOpenPay={setIsOpenPay} isOpenPayLoad={isOpenPayLoad} activeView={activeView}/>} />
              <Route path="activate" element={<Activate />} />
              <Route path="forgot" element={<Forgot />} />
            </Routes>
          </BrowserRouter>
        </div>
        <Grid container>
            <LanguageComponent setLanguage={setLanguage} setLanguageText={setLanguageText} language={language} isOpenLanguage={isOpenLanguage} setIsOpenLanguage={setIsOpenLanguage}></LanguageComponent>
        </Grid>
      </div>
    );
}

export default App;
